module.exports = ".required{\n  color: red;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ticket-view/modals/add-feedback-modal/add-feedback-modal.component.css
// module id = ./src/app/ticket-view/modals/add-feedback-modal/add-feedback-modal.component.css
// module chunks = main